import { FC, StrictMode } from 'react'
import { AuthContext, AuthProvider } from 'react-oidc-context'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import { getOidcConfig } from '../../oidc'
import { persistor, store } from '../../store'
import { LocalizedThemedContainer } from '../LocalizedThemedContainer'

const AUTH_DISABLED = process.env.REACT_APP_AUTH_DISABLED === 'true'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mockAuthContextValue: any = {
  isAuthenticated: true,
  isLoading: false,
  user: { access_token: 'disabled', id_token: 'disabled' },
  events: {
    addUserLoaded: () => {},
    removeUserLoaded: () => {},
    addUserUnloaded: () => {},
    removeUserUnloaded: () => {},
    addAccessTokenExpiring: () => {},
    removeAccessTokenExpiring: () => {},
    addAccessTokenExpired: () => {},
    removeAccessTokenExpired: () => {},
    addSilentRenewError: () => {},
    removeSilentRenewError: () => {},
  },
  signinRedirect: async () => {},
  signinSilent: async () => null,
  signoutRedirect: async () => {},
  removeUser: async () => {},
  clearStaleState: async () => {},
}

export const Root: FC = () => {
  const inner = (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <LocalizedThemedContainer />
      </PersistGate>
    </Provider>
  )

  return (
    <StrictMode>
      {AUTH_DISABLED ? (
        <AuthContext.Provider value={mockAuthContextValue}>{inner}</AuthContext.Provider>
      ) : (
        <AuthProvider {...getOidcConfig()}>{inner}</AuthProvider>
      )}
    </StrictMode>
  )
}
